{
  "actions": "Действия",
  "actionsAvailable": "Налични действия.",
  "clearSelection": "Изчистване на избора",
  "selected": "{count, plural, =0 {Няма избрани} other {# избрани}}",
  "selectedAll": "Всички избрани"
}
